export const INFO_TOAST_KEY = 'infoToast';
